export default __webpack_public_path__ + "static/media/TSS-Button.44159e0a.png";